import VS from "constants/ValidationShema";
import Tr from "translations/Translations";

const stageValidation = (stage, approval) => {
    const stageModel = approval.stages.find(s => s.identity === stage.identity);
    const stageShape = {
        approvers: VS.any().test('min_selected', Tr('selectApproversMinCountError'), () => {
            return stage.approvers.filter(a => a.selected === true).length >= stageModel.minAssignedApproverCount;
        }),
        assigneeComment: VS.stringMaxNoRq(255).test('not_empty', Tr('required_field'), () => {
            return !stageModel.useAssignerComments || stage.assigneeComment.length > 0;
        })
    };

    return VS.object(stageShape);
}

export const selectApproversValidationShema = (approval) => {
    return VS.object({
        stages: VS.arrayOf(VS.lazy(stage => stageValidation(stage, approval)))
    });
}

export const approvalDecisionValidationSchema = (stage) => {
    return VS.lazy(approvalDecision => {
        const shape = {
            decision: VS.string(),
            approverComment: VS.stringNoRq().test('reject_comment', Tr('approverRejectCommentRequired'), () => {
                return !!approvalDecision.approverComment || (approvalDecision.decision === 'accept' && !stage.acceptRequireComment)
                    || (approvalDecision.decision === 'reject' && !stage.rejectRequireComment)
                    || (approvalDecision.decision === 'masterApprove' && !stage.masterApproveRequireComment)
                    || (approvalDecision.decision === 'masterReject' && !stage.masterRejectRequireComment)
                    || (approvalDecision.decision === 'masterStop' && !stage.masterStopRequireComment);
            })
        }
        return VS.object(shape);
    })
}